import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";

export default {

  campos() {
    return [
      {nome: 'Texto', id: 'INPUT', icon: 'fal fa-font'},
      {nome: 'Data', id: 'DATE', icon: 'fal fa-calendar'},
      {nome: 'Número', id: 'NUMBER', icon: 'fal fa-hashtag'},
      {nome: 'Moeda', id: 'CURRENCY', icon: 'fal fa-usd-circle'},
      {nome: 'Sim/Não', id: 'BOOLEAN', icon: 'fal fa-check-square'},
      {nome: 'Condições Personalizadas', id: 'SELECT', icon: 'fal fa-list-ol'},
      {nome: 'Lista Predefinida', id: 'LIST', icon: 'fal fa-list-alt'},
      {nome: 'Título Estático', id: 'LABEL', icon: 'fal fa-info-square'},
      {nome: 'Texto Formatado', id: 'EDITOR', icon: 'fal fa-file-alt'},
      {nome: 'Grupo', id: 'GROUP', icon: 'fal fa-object-group'},
      {nome: 'Vinculo', id: 'VINCULO', icon: 'fal fa-link'},
      {nome: 'Fragmento de Checklist', id: 'CHECKLIST', icon: 'fal fa-external-link-alt'},
      {nome: 'Condição Automática', id: 'AUTOMATICO', icon: 'fal fa-list-ol'},
      {nome: 'Upload de Imagem', id: 'IMAGEM', icon: 'fal fa-upload'},
      {nome: 'Exigência', id: 'EXIGENCIA', icon: 'fal fa-exclamation-triangle'},
    ]
  },

  mascaras() {
    return [
      {nome: 'Nenhum', id: 'text'},
      {nome: 'CPF', id: 'cpf'},
      {nome: 'CNPJ', id: 'cnpj'},
    ]
  },

  vinculos() {
    return [
      {nome: 'Indicador Real', id: 'INDICADOR_REAL'},
      {nome: 'Indicador Real - Ato', id: 'ATO_INDICADOR_REAL'},
      {nome: 'Registro Auxiliar', id: 'REGISTRO_AUXILIAR'},
      {nome: 'Registro Auxiliar - Ato', id: 'ATO_REGISTRO_AUXILIAR'},
      {nome: 'Indicador Pessoal', id: 'INDICADOR_PESSOAL'},
      {nome: 'Protocolo', id: 'DOCUMENTO'},
      {nome: 'Título', id: 'TITULO'},
      {nome: 'Registro RTD', id: 'REGISTRO_TD'},
      {nome: 'Registro RTD - Ato', id: 'ATO_REGISTRO_TD'},
      {nome: 'Registro RCPJ', id: 'REGISTRO_PJ'},
      {nome: 'Registro RCPJ - Ato', id: 'ATO_REGISTRO_PJ'},
    ]
  },

  apresentacao() {
    return [
      {nome: 'Select', id: 'select'},
      {nome: 'Checkbox', id: 'checkbox'},
      {nome: 'Radio', id: 'radio'},
    ]
  },

  apresentacaoSingular() {
    return [
      {nome: 'Oculto', id: 'hidden'},
      {nome: 'Select', id: 'select'},
      {nome: 'Radio', id: 'radio'},
    ]
  },

  apresentacaoTitulo() {
    return [
      {nome: 'Select', id: 'select'},
      {nome: 'Radio', id: 'radio'},
    ]
  },

  exigencia() {
    return [
      {nome: 'Individual', id: 'individual'},
      {nome: 'Não Selecionados', id: 'unchecked'},
      {nome: 'Geral - Nenhum Selecionado', id: 'vazio'},
      {nome: 'Geral - Seleção incompleta', id: 'incompleto'},
    ]
  },

  /**
   * Se o requisito deixa reescrever à mão o texto da exigência no checklist respondido.
   *
   * Sem valor (null) o requisito herda a configuração do cartório em Administração → Sistema →
   * Exigência ("Permitir Editar Exigência no Checklist?"). Definido, sobrescreve para os dois
   * lados: libera onde a configuração global está desligada, e bloqueia onde está ligada.
   */
  edicaoExigencia() {
    return [
      {nome: 'Padrão do sistema', id: null},
      {nome: 'Sempre permitir', id: true},
      {nome: 'Nunca permitir', id: false},
    ]
  },

  /**
   * Normaliza a flag para `true`, `false` ou `null` (padrão do sistema).
   *
   * Existe porque o `<select>` do V-Input entrega o valor do DOM, que é sempre String: o evento
   * `input` nativo do select chega ANTES do `change`, e é o handler do `input` que emite para o
   * v-model do componente (`inputEvent` lê `e.target.value`) — o `change`, onde o v-model interno
   * já resolveu o `_value` real da option, só emite `change`. Com opções de id booleano, portanto,
   * `false` volta como `"false"` e `null` como `""`.
   *
   * Era isso que anulava a configuração por requisito: a comparação estrita não casava com a
   * String, todo requisito caía no padrão do cartório e as três opções davam no mesmo. Normalizar
   * aqui cobre de uma vez a leitura do que já foi gravado como String e a gravação nova.
   */
  normalizarEdicaoExigencia(valor) {
    if (valor === true || valor === 'true') {
      return true;
    }
    if (valor === false || valor === 'false') {
      return false;
    }
    return null;
  },

  /**
   * Resolve a flag do requisito contra a configuração do cartório. Ponto único: a tela de resposta
   * e o modal de edição precisam concordar.
   */
  permiteEditarExigencia(requisito, padraoDoSistema = false) {
    const flag = this.normalizarEdicaoExigencia(requisito?.permitirEditarExigencia);
    return flag === null ? !!padraoDoSistema : flag;
  },

  multiplicador() {
    return [
      {nome: 'Manual', id: 'manual'},
      // {nome: 'Matrículas', id: 'matricula'},
      {nome: 'Envolvidos', id: 'envolvido'},
    ]
  },

  automacao() {
    return [
      {id: 'CATEGORIA_IMOVEL', nome: 'Categoria do Imóvel', condicoes : ['Urbano', 'Rural']},
      {id: 'ESTADO_CIVIL', nome: 'Estado Civil', condicoes : ['Solteiro', 'Casado', 'Separado', 'Divorciado', 'Viúvo', 'Não Informado', 'União Estável']},
      {id: 'TIPO_PESSOA', nome: 'Tipo de Pessoa', condicoes : ['Pessoa física', 'Pessoa jurídica']},
      {id: 'POSSUI_DEVEDOR', nome: 'Ato Possui Devedor?', condicoes : ['Sim', 'Não']},
      {id: 'UNIDADE_AUTONOMA', nome: 'Imóvel é Unidade Autônoma?', condicoes : ['Sim', 'Não']},
      {id: 'INDIVIDUO_MENOR', nome: 'Menor?', condicoes : ['Sim', 'Não']},
      {id: 'INDIVIDUO_INCAPAZ', nome: 'Incapaz?', condicoes : ['Sim', 'Não']},
      {id: 'INDIVIDUO_FALECIDO', nome: 'Falecido?', condicoes : ['Sim', 'Não']},

      {id: 'REGIME_CASAMENTO', nome: 'Regime do Casamento', condicoes : IndicadorPessoalBusiness.getRegimes().map(e => e.nome)},
      {id: 'CASAMENTO_APOS_LEI_6515', nome: 'Casamento após lei 6515?', condicoes : ['Sim', 'Não']},

      {id: 'LIVRO', nome: 'Livro do Ato', condicoes : ['MATRICULA', 'REGISTRO_AUXILIAR', 'TRANSCRICAO']},

      {id: 'PAPEL', nome: 'Papel', condicoes : []},
    ]
  },

  titulo() {
    return [
      {nome: 'Label', id: 'LABEL'},
      {nome: 'Alerta', id: 'ALERT'},
    ]
  },

}
